module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0092.jpg?v=97059a4a";